<div>
    <h2 data-testid="adx-booking-details-title" class="page-details-title-style">Booking {{bookingData.id}}</h2>
</div>

<mat-tab-group dynamicHeight (selectedTabChange)="tabChanged($event)">
  <mat-tab label="General Info">
      <app-adx-booking-info [data]="bookingData" [payStatusesOptions]="payStatusesList"
        (submitedData)="submitedDataHandler($event)" (confirmCopyService)="confirmCopyServiceHandler($event)"></app-adx-booking-info>
  </mat-tab>
    @if (bookingData.adxAgentBookings && bookingData.adxAgentBookings.length > 0){
        <mat-tab label="Agents">
            <br>
            @for (adxAgentBooking of bookingData.adxAgentBookings; track adxAgentBooking?.id) {
                <app-adx-agent-booking-info [data]="adxAgentBooking"></app-adx-agent-booking-info>
            }
        </mat-tab>
    }
    <mat-tab label="Udids">
        <app-adx-booking-udid-info [data]="bookingData"></app-adx-booking-udid-info>
    </mat-tab>
    @if(bookingData?.travelType?.id == 6) {
        <mat-tab label="Segments">
            <div class="m-b-1"></div>
            <button *ngIf="loggedInUserHasDirectorOrFinanceOrManagerRole()" data-testid="adx-booking-details-add-segment-button" mat-raised-button color="primary"
                (click)="onAddSegment();" style="margin-left: 100px;">Add</button>
            @for (adxBookingSegment of bookingData.adxBookingSegments; track adxBookingSegment?.id) {
                <app-adx-booking-segment-info [data]="adxBookingSegment"></app-adx-booking-segment-info>
            }
        </mat-tab>
    }
    @if(bookingData?.adxHotelBookingExtension) {
        <mat-tab label="Hotel">
            <br>
            <app-adx-booking-hotel-info [data]="bookingData.adxHotelBookingExtension"></app-adx-booking-hotel-info>
        </mat-tab>
    }
    @if(bookingData?.adxBookingSupportFeeExtension) {
        <mat-tab label="Support Fee">
            <br>
            <app-adx-booking-support-fee-info [data]="bookingData.adxBookingSupportFeeExtension"></app-adx-booking-support-fee-info>
        </mat-tab>
    }
    @if(bookingData?.adxBookingMarkupTypeExtension) {
        <mat-tab label="Markup">
            <br>
            <app-adx-booking-markup-info [data]="bookingData.adxBookingMarkupTypeExtension"></app-adx-booking-markup-info>
        </mat-tab>
    }
    @if(bookingData?.adxInterCompanyLine) {
        <mat-tab label="Intercompany">
            <br>
            <app-adx-booking-inter-company-line-info [data]="bookingData.adxInterCompanyLine"></app-adx-booking-inter-company-line-info>
        </mat-tab>
    }
</mat-tab-group>
